const fr = {
  welcome: {
    tagline1: 'Faites vos choix.',
    tagline2: 'Grimpez au classement.',
    tagline3: 'Gagnez des prix.',
    howToPlay: 'Comment jouer',
    letsPlay: 'Jouez',
  },
  howToPlay: {
    back: 'Retour',
    title: 'Comment jouer',
    step1Title: "Pick'Em",
    step1Description: 'Verrouillez vos prédictions avant le début du match',
    step2Title: 'Marquez gros',
    step2Description: 'Chaque bon choix vous rapporte des points',
    step3Title: 'Battez la concurrence',
    step3Description: 'Dépassez amis et partisans au classement',
    step4Title: 'À vous la gloire',
    step4Description: 'Gagnez des prix et montrez qui est le meilleur',
    cta: 'Jouez',
  },
  game: {
    status: {
      loading: 'Chargement...',
      live: 'EN DIRECT',
      complete: 'Terminé',
      correct: 'correct',
    },
    actions: {
      edit: 'Modifier',
      editPicks: 'Modifier les choix',
      viewPicks: 'Voir les choix',
      playNow: 'Jouer maintenant',
      leaderboard: 'Classement',
      viewLeaderboard: 'Classement',
      viewResults: 'Voir les résultats',
    },
    results: {
      rank: 'Rang',
      totalPts: 'Total Pts',
    },
    labels: {
      start: 'Début:',
      picks: 'Choix:',
      firstPrize: '1er prix:',
      vs: 'vs',
      yes: 'Oui',
      no: 'Non',
    },
    time: {
      day: 'Jour',
      days: 'Jours',
      hour: 'Heure',
      hours: 'Heures',
      soon: 'Bientôt',
      startingSoon: 'Commence bientôt...',
    },
    contestClosed: 'Ce match a commencé et ce concours est fermé.',
    ordinals: {
      st: 'er',
      nd: 'e',
      rd: 'e',
      th: 'e',
    },
  },
  navigation: {
    filter: 'Filtrer',
    edit: 'Modifier',
    chat: 'Discussion',
    code: 'Code',
  },
  actions: {
    clear: 'Effacer',
    clearSelection: 'Effacer la sélection',
    quickPick: 'Choix Rapide',
    favouritePick: 'Choix Préféré',
    contestDetails: 'Détails du concours',
    moreOptions: 'Plus d’options',
    submitPicks: 'Soumettre les choix',
    submitting: 'Soumission...',
  },
  tabs: {
    lobby: 'Lobby',
    myPicks: 'Mes Choix',
    play: 'Jouer',
    recent: 'Récent',
    leaderboard: 'Classement',
  },
  leaderboard: {
    today: "Aujourd'hui",
    week: 'Semaine',
    season: 'Saison',
    daily: 'Quotidien',
    monthly: 'Mensuel',
    rank: 'Rang',
    user: 'Utilisateur',
    points: 'Points',
    pickem: 'Pickem',
    pickemLeaderboard: 'Classement Pickem',
    close: 'Fermer',
    scrollForMore: 'Faites défiler pour plus',
    failedToLoad: 'Échec du chargement du classement. Veuillez réessayer.',
    noData: 'Aucune donnée de classement disponible pour cette période.',
  },
  pages: {
    gamesCount: 'Sélectionnez un concours',
    recentResults: 'Résultats récents ({{count}})',
    noGamesAvailable: "Actuellement, il n'y a pas de jeux PICK'EM disponibles",
    noCompletedGames: "Il n'y a pas encore de jeux PICK'EM terminés.",
  },
  common: {
    picks: 'choix',
  },
  auth: {
    loginUnavailableTitle: 'Impossible d’accéder à la page de connexion',
    loginUnavailableSubtitle: 'Veuillez vérifier votre connexion et réessayer.',
    retry: 'Réessayer',
  },
  footer: {
    termsAndConditions: 'Termes et Conditions',
  },
  tiebreaker: {
    title: "Bris d'égalité",
  },
  modal: {
    picksSubmitted: {
      title: 'Sélections soumises',
      message: 'Vos sélections ont été enregistrées.',
      editMessage: "Modifiez-les à tout moment avant le coup d'envoi.",
      returnToLobby: 'Retour au lobby',
      viewMyPicks: 'Voir mes sélections',
    },
  },
} as const;

export default fr;
